import moment from 'moment';

import { SearchPatientFormValues } from 'src/components/SearchPatientInfoFormGroup/SearchPatientInfoFormGroup';

import { EntityCriteriaOperatorEnum } from 'src/models/GalenData/EntityCriteria.model';
import { IGetUsersRequestBody } from 'src/models/GalenData/Request.model';
import { GalenDataUserColumn } from 'src/models/GalenData/User.model';
import { UserRoleEnum } from 'src/models/GalenData/UserRole.model';

export interface SanitizedSearchPatientValues {
  key: keyof GalenDataUserColumn | keyof IGetUsersRequestBody;
  value: string | undefined;
  operator: EntityCriteriaOperatorEnum;
}

export const sanitizeSearchPatientValues = (
  searchValues: SearchPatientFormValues | undefined,
) => {
  const { dob, firstName, lastName, id } = searchValues || {};

  return [
    {
      key: 'dateOfBirth' as const,
      value: dob ? moment(dob).format('YYYY-MM-DD') : undefined,
      operator: EntityCriteriaOperatorEnum.Equal,
    },
    {
      key: 'firstName' as const,
      value: firstName?.trim(),
      operator: EntityCriteriaOperatorEnum.Like,
    },
    {
      key: 'lastName' as const,
      value: lastName?.trim(),
      operator: EntityCriteriaOperatorEnum.Like,
    },
    {
      key: 'patientId' as const,
      value: id?.trim(),
      operator: EntityCriteriaOperatorEnum.Like,
    },
  ].filter(({ value }) => value);
};

export const getPatientFilterConditions = (
  sanitizedSearchValues: SanitizedSearchPatientValues[],
) => {
  const filterConditions: SanitizedSearchPatientValues[] = [
    ...sanitizedSearchValues,
    {
      key: 'role',
      value: UserRoleEnum.Patient,
      operator: EntityCriteriaOperatorEnum.Equal,
    },
  ];

  return filterConditions.map(({ key, value, operator }) => ({
    key,
    value,
    operator,
    isCustomField: false,
  }));
};
